import { Avatar, Chip, TableCell, Checkbox } from '@mui/material'
import React from 'react'
import classes from '../DataTable.module.css'
import StopIcon from '@mui/icons-material/Stop'
import { useDispatch, useSelector } from 'react-redux'
import {
  setEmployeeID,
  setOpenIndividualStudent,
  setOpenIndividualTeacher,
  setSchoolDInfo,
  setSectionID,
  setSectionOpen,
  setStudentID,
} from '../../../redux/globalSlice'
import { toast } from 'react-toastify'
// import { useGlobal } from '../../../shared'
// import { urls } from '../../../shared/config'

export const formatDate = (dateString) => {
  const date = new Date(dateString)
  const day = date.getDate()
  const month = date.toLocaleString('default', { month: 'short' })
  const year = date.getFullYear().toString()
  return `${day}-${month}-${year}`
}

export const StudentFields = ({ row, labelId, search }) => {
  // console.log('---------row', row)

  const dispatch = useDispatch()

  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row.student_registration_number}
      </TableCell>
      <TableCell
        onClick={() => {
          dispatch(setOpenIndividualStudent(true))
          dispatch(setSchoolDInfo(row))
          dispatch(setStudentID(row?.student_id))
        }}
        align="left"
      >
        <TableImageHolder
          fieldImage={row.student_avatar}
          fieldName={row.student_name}
          avatarColor={getColorForStudent(row.student_id)}
        />
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_grade} - {row.student_section}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_father_name}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_father_contact}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <Checkbox checked={row.student_van_facility} />
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_exam_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_fee_discount}
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_transport_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_misc_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_last_year_due_fee}
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {search ? row.student_total_fee : row.student_total_fee}
      </TableCell>
      {/* <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.student_fee_status == 'Paid'
                ? classes.activeStatus
                : row.student_fee_status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.student_fee_status == 'Paid'
                    ? '#14804a'
                    : row.student_fee_status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.student_fee_status}
          </span>
        </div>
      </TableCell> */}
      {/* 
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_balance_amount}
      </TableCell> */}

      <TableCell align="center">
        <span
          className={row.student_account_status === true ? classes.activeStatus : classes.reject}
        >
          <StopIcon
            sx={{ color: row.student_account_status === true ? '#14804a' : '#d1293d' }}
            fontSize="10px"
          />
          {row.student_account_status == true ? 'Active' : 'Inactive'}
        </span>
      </TableCell>
    </>
  )
}
export const StudentTransportFields = ({ row, labelId, search }) => {
  // console.log('---------row', row)

  const dispatch = useDispatch()

  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row.student_id}
      </TableCell>
      <TableCell
        onClick={() => {
          // dispatch(setOpenIndividualStudent(true))
          dispatch(setSchoolDInfo(row))
        }}
        align="left"
      >
        <TableImageHolder
          fieldImage={row.student_avatar}
          fieldName={row.student_name}
          avatarColor={getColorForStudent(row.student_id)}
        />
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.grade_name} - {row.section_name}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.transport_fee_status == 'Paid'
                ? classes.activeStatus
                : row.transport_fee_status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.transport_fee_status == 'Paid'
                    ? '#14804a'
                    : row.transport_fee_status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.transport_fee_status}
          </span>
        </div>
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_transport_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_transport_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.van_number}
      </TableCell>
    </>
  )
}

export const StudentPresenceFields = ({ row, labelId, search }) => {
  // console.log('---------row', row)

  const dispatch = useDispatch()

  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.user_id}
      </TableCell>
      <TableCell
        onClick={() => {
          dispatch(setOpenIndividualStudent(true))
        }}
        align="left"
      >
        <TableImageHolder
          fieldImage={row?.student_avatar}
          fieldName={row?.student_name}
          avatarColor={getColorForStudent(row?.user_id)}
        />
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.attendance_type == 'present'
                ? classes.activeStatus
                : row.attendance_type == 'leave'
                  ? classes.partial
                  : row.attendance_type == 'pending'
                    ? classes.pending
                    : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.attendance_type == 'present'
                    ? '#14804a'
                    : row.attendance_type == 'leave'
                      ? '#f0d137'
                      : row.attendance_type == 'pending'
                        ? '#667085'
                        : '#d1293d',
              }}
              fontSize="10px"
            />
            {row?.attendance_type}
          </span>
        </div>
      </TableCell>
    </>
  )
}

export const EmployeePresenceFields = ({ row, labelId, search }) => {
  // console.log('---------row', row)

  const dispatch = useDispatch()

  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.user_id}
      </TableCell>
      <TableCell
        onClick={() => {
          dispatch(setOpenIndividualStudent(true))
        }}
        align="left"
      >
        <TableImageHolder
          fieldImage={row?.employee_name}
          fieldName={row?.employee_name}
          avatarColor={getColorForStudent(row?.user_id)}
        />
      </TableCell>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {formatDate(row?.attendance_date)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.attendance_type == 'present'
                ? classes.activeStatus
                : row.attendance_type == 'leave'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.attendance_type == 'present'
                    ? '#14804a'
                    : row.attendance_type == 'leave'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row?.attendance_type}
          </span>
        </div>
      </TableCell>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.employee_contact_number}
      </TableCell>
    </>
  )
}

export const SchoolFielfd = ({ row, labelId }) => {
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row.school_id}
      </TableCell>
      <TableCell align="center">{row.school_name}</TableCell>
      <TableCell align="center">{row.gradeCount}</TableCell>
      <TableCell align="center">{row.studentCount}</TableCell>
      <TableCell align="center">{row.teacherCount}</TableCell>
    </>
  )
}

export const RoutesField = ({ row, labelId, rowIndex }) => {
  // console.log('---row', row)

  return (
    <>
      <TableCell sx={{ width: '140px' }} align="lwft" component="th" id={labelId}>
        {rowIndex + 1}
      </TableCell>
      <TableCell align="center" sx={{ width: '60px' }}>
        <div className={classes.statusContainer}>
          <span className={classes.activeStatus}>{row.route_name}</span>
        </div>
      </TableCell>
      <TableCell align="left">
        {row.vans
          ?.map((van) => `${van.van_number} ${van?.van_driver && `(${van.van_driver})`}`)
          .join(', ') || '—'}
      </TableCell>
      <TableCell align="left">{parseInt(row.stops_count, 10)}</TableCell>
      <TableCell align="left">{parseInt(row.student_count, 10)}</TableCell>
    </>
  )
}

export const ClassFielfd = ({ row, labelId }) => {
  const dispatch = useDispatch()
  // const sectionID = useSelector((state) => state.global.sectionId)
  // console.log('--------row', row)

  const handleSectionClick = (section) => {
    const newGradeSection = section.section_map_id
    dispatch(setSectionID(newGradeSection))
    dispatch(setSectionOpen(true))
  }
  return (
    <>
      <TableCell
        sx={{ width: '20px' }}
        align="center"
        component="th"
        id={labelId}
        scope="row"
        padding="none"
      >
        {row.grade_id}
      </TableCell>
      <TableCell align="center">{row.grade}</TableCell>
      <TableCell align="center" className="section-l-items">
        {row.grade_sections?.map((sectionObj, index) => (
          <Chip
            sx={{ mr: 1 }}
            key={index}
            label={sectionObj.section}
            onClick={() => handleSectionClick(sectionObj)}
            className="sections-box"
          />
        ))}
      </TableCell>
      <TableCell align="center">{row.exam_fee}</TableCell>
      <TableCell align="center">{row.tuition_fee}</TableCell>
    </>
  )
}

export const EmployeeFielfd = ({ row, labelId }) => {
  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row.employee_id}
      </TableCell>
      <TableCell align="left" sx={{ pl: 10 }}>
        <TableImageHolder
          fieldImage={row.employee_avatar}
          fieldName={row.employee_name}
          avatarColor={getColorForStudent(row.employee_id)}
        />
      </TableCell>
      <TableCell align="center">{row.employee_type}</TableCell>
      <TableCell align="center">
        <div className="image-con-cell">
          <span
            className={row.employee_account_status === true ? classes.activeStatus : classes.reject}
          >
            <StopIcon
              sx={{ color: row.employee_account_status === true ? '#14804a' : '#d1293d' }}
              fontSize="10px"
            />
            {row.employee_account_status == true ? 'Active' : 'Inactive'}
          </span>
        </div>
      </TableCell>

      <TableCell align="center">{row.employee_contact_number}</TableCell>
    </>
  )
}

export const TeacherFields = ({ row, labelId }) => {
  const dispatch = useDispatch()
  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.employee_id}
      </TableCell>
      <TableCell
        onClick={() => {
          dispatch(setEmployeeID(row?.employee_id))
          dispatch(setOpenIndividualTeacher(true))
        }}
        align="center"
        sx={{ pl: 3 }}
      >
        <TableImageHolder
          fieldImage={row.employee_avatar}
          fieldName={row.employee_name}
          avatarColor={getColorForStudent(row.employee_id)}
        />
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.employee_salary}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {formatDate(row.employee_joining_date)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.grade} - {row.section}
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.employee_contact_number}
      </TableCell>
      <TableCell align="center">
        <div className="image-con-cell">
          <span
            className={row.employee_account_status === true ? classes.activeStatus : classes.reject}
          >
            <StopIcon
              sx={{ color: row.employee_account_status === true ? '#14804a' : '#d1293d' }}
              fontSize="10px"
            />
            {row.employee_account_status == true ? 'Active' : 'Inactive'}
          </span>
        </div>
      </TableCell>
    </>
  )
}

export const FeesFields = ({ row, labelId, handleIndividualOpen }) => {
  const dispatch = useDispatch()
  const selected = useSelector((state) => state.global.selectedRow)
  const { student_id } = row
  const handleOpenCollect = () => {
    if (selected.length != 0) {
      // toast.error('Select a row')
      dispatch(setStudentID(student_id))
      dispatch(setSchoolDInfo(row))
      // dispatch(setOpenFeeConfirm(true))
      handleIndividualOpen()
    } else {
      dispatch(setStudentID(student_id))
      // dispatch(setOpenFeeConfirm(true))
      handleIndividualOpen()
    }
  }
  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  // console.log('-----row', row)

  // const { data: feeDetail } = useGlobal({ userUrl: `${urls.FEE_DETAIL}${student_id}` })
  // const feeInfo = feeDetail && feeDetail?.feeInvoice
  // const payments = feeInfo && feeInfo[0] && feeInfo[0]?.payments
  // const totalAmount = payments?.reduce((total, pay) => total + pay?.payment_amount, 0)

  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.student_registration_number}
      </TableCell>
      <TableCell align="center" onClick={handleOpenCollect} sx={{ pl: 5 }}>
        <TableImageHolder
          fieldImage={row.student_avatar}
          fieldName={row.student_name}
          fee
          avatarColor={getColorForStudent(student_id)}
        />
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_grade} - {row.student_section}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.fee_status == 'Paid'
                ? classes.activeStatus
                : row.fee_status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.fee_status == 'Paid'
                    ? '#14804a'
                    : row.fee_status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.fee_status}
          </span>
        </div>
      </TableCell>
      {/* <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_last_year_due}
      </TableCell> */}
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_tuition_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_monthly_tuition_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_amount}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_exam_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_misc_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_fee_discount}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_balance}
      </TableCell>
    </>
  )
}

export const ExpenseFields = ({ row, labelId }) => {
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row.expense_id}
      </TableCell>
      <TableCell align="center">{row.expense_title}</TableCell>
      <TableCell align="center">{row.expense_category}</TableCell>
      <TableCell align="center">{row.employee_name || '-'}</TableCell>
      <TableCell align="center">{formatDate(row.expense_date)}</TableCell>
      <TableCell align="center">
        <span className="expense-desc">{row.expense_description || '-'}</span>
      </TableCell>
      <TableCell align="center">{row.expense_amount}</TableCell>
      {/* <TableCell align="center">{row.expense_paid_to}</TableCell> */}
    </>
  )
}
export const SubjectFields = ({ row, labelId }) => {
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row.subject_name}
      </TableCell>
      {/* <TableCell align="center">{row.expense_paid_to}</TableCell> */}
    </>
  )
}

export const VanDriverField = ({ row, labelId, rowIndex }) => {
  const driver_id = rowIndex + 1
  const [avatarColors, setAvatarColors] = React.useState({})
  const getColorForStudent = (studentId) => {
    if (avatarColors[studentId]) {
      return avatarColors[studentId]
    } else {
      const newColor = getRandomColor()
      setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
      return newColor
    }
  }
  return (
    <>
      <TableCell align="center" component="th" id={labelId}>
        {driver_id}
      </TableCell>
      <TableCell align="center" justify="center">
        <TableImageHolder
          fieldImage={row.employee_avatar}
          fieldName={row.employee_name}
          avatarColor={getColorForStudent(row.employee_id)}
          align="center"
          justify="center"
        />
      </TableCell>
      <TableCell align="center">{row.employee_contact_number}</TableCell>
    </>
  )
}
export const VanListField = ({ row, labelId }) => {
  return (
    <>
      <TableCell align="center" component="th" id={labelId}>
        {row.van_number}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.employee_name}
      </TableCell>
      <TableCell align="center">
        <div className={classes.statusContainer}>
          <span className={classes.activeStatus}>{row.route_name}</span>
        </div>
      </TableCell>
      <TableCell align="center" sx={{ width: '40px' }}>
        {row.van_size}
      </TableCell>
      <TableCell align="center">{row.employee_contact_number}</TableCell>
    </>
  )
}
export const getRandomColor = () => {
  const hue = Math.floor(Math.random() * 360)
  const saturation = 70 + Math.random() * 30
  const lightness = 50
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}
export const TableImageHolder = ({ fieldImage, fieldName, fee, avatarColor }) => {
  return (
    <div className={classes['emp-name']}>
      <div className={classes.empImg}>
        {fieldImage ? (
          <img
            src={fieldImage}
            style={{
              width: '26px',
              height: '26px',
              // borderRadius:'50%'
            }}
            alt={''}
          />
        ) : (
          <Avatar
            alt={''}
            sx={{
              width: '26px',
              height: '26px',
              fontSize: '18px',
              backgroundColor: avatarColor,
            }}
          >
            {fieldName?.charAt(0)?.toUpperCase()}
          </Avatar>
        )}
      </div>

      {fee ? <span className="fee-student">{fieldName}</span> : fieldName}
    </div>
  )
}

export const CreditFields = ({ row, labelId, rowIndex }) => {
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {rowIndex}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.employee_name}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.employee_type}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.employee_credit_count}
      </TableCell>
      {/* <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.student_fee_status == 'Paid'
                ? classes.activeStatus
                : row.student_fee_status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.student_fee_status == 'Paid'
                    ? '#14804a'
                    : row.student_fee_status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.student_fee_status}
          </span>
        </div>
      </TableCell> */}
    </>
  )
}
export const IndividualFeesRow = ({ row, labelId }) => {
  // const [avatarColors, setAvatarColors] = React.useState({})
  // const getColorForStudent = (studentId) => {
  //   if (avatarColors[studentId]) {
  //     return avatarColors[studentId]
  //   } else {
  //     const newColor = getRandomColor()
  //     setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
  //     return newColor
  //   }
  // }

  // const { data: feeDetail } = useGlobal({ userUrl: `${urls.FEE_DETAIL}${student_id}` })
  // const feeInfo = feeDetail && feeDetail?.feeInvoice
  // const payments = feeInfo && feeInfo[0] && feeInfo[0]?.payments
  // const totalAmount = payments?.reduce((total, pay) => total + pay?.payment_amount, 0)
  // const totalAmount = row?.student_tuition_fee
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.month}
      </TableCell>
      {/* <TableCell align="center" onClick={handleOpenCollect} sx={{ pl: 5 }}>
        <TableImageHolder
          fieldImage={row.student_avatar}
          fieldName={row.student_name}
          fee
          avatarColor={getColorForStudent(student_id)}
        />
      </TableCell> */}
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_monthly_tuition_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.status == 'Paid'
                ? classes.activeStatus
                : row.status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.status == 'Paid'
                    ? '#14804a'
                    : row.status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.status}
          </span>
        </div>
      </TableCell>
      {/* <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_last_year_due}
      </TableCell> */}

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {parseInt(row.student_misc_fee, 10)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_balance?.toFixed(2)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_fee_discount}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_amount}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_exam_fee}
      </TableCell>
    </>
  )
}
export const IndividualStudentRow = ({ row, labelId }) => {
  // console.log('-----row in id viudal student', row)
  // const [avatarColors, setAvatarColors] = React.useState({})
  // const getColorForStudent = (studentId) => {
  //   if (avatarColors[studentId]) {
  //     return avatarColors[studentId]
  //   } else {
  //     const newColor = getRandomColor()
  //     setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
  //     return newColor
  //   }
  // }

  // const { data: feeDetail } = useGlobal({ userUrl: `${urls.FEE_DETAIL}${student_id}` })
  // const feeInfo = feeDetail && feeDetail?.feeInvoice
  // const payments = feeInfo && feeInfo[0] && feeInfo[0]?.payments
  // const totalAmount = payments?.reduce((total, pay) => total + pay?.payment_amount, 0)
  // const totalAmount = row?.student_tuition_fee

  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.month}
      </TableCell>
      {/* <TableCell align="center" onClick={handleOpenCollect} sx={{ pl: 5 }}>
        <TableImageHolder
          fieldImage={row.student_avatar}
          fieldName={row.student_name}
          fee
          avatarColor={getColorForStudent(student_id)}
        />
      </TableCell> */}
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_monthly_tuition_fee}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.status == 'Paid'
                ? classes.activeStatus
                : row.status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.status == 'Paid'
                    ? '#14804a'
                    : row.status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.status}
          </span>
        </div>
      </TableCell>
      {/* <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_last_year_due}
      </TableCell> */}

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {parseInt(row.student_misc_fee, 10)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_balance?.toFixed(2)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.student_fee_discount}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_amount}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_exam_fee}
      </TableCell>
    </>
  )
}
export const IndividualTeacherRow = ({ row, labelId }) => {
  // const [avatarColors, setAvatarColors] = React.useState({})
  // const getColorForStudent = (studentId) => {
  //   if (avatarColors[studentId]) {
  //     return avatarColors[studentId]
  //   } else {
  //     const newColor = getRandomColor()
  //     setAvatarColors((prevColors) => ({ ...prevColors, [studentId]: newColor }))
  //     return newColor
  //   }
  // }

  // const { data: feeDetail } = useGlobal({ userUrl: `${urls.FEE_DETAIL}${student_id}` })
  // const feeInfo = feeDetail && feeDetail?.feeInvoice
  // const payments = feeInfo && feeInfo[0] && feeInfo[0]?.payments
  // const totalAmount = payments?.reduce((total, pay) => total + pay?.payment_amount, 0)
  // const totalAmount = row?.student_tuition_fee
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row?.employee_salary}
      </TableCell>
      {/* <TableCell align="center" onClick={handleOpenCollect} sx={{ pl: 5 }}>
        <TableImageHolder
          fieldImage={row.student_avatar}
          fieldName={row.student_name}
          fee
          avatarColor={getColorForStudent(student_id)}
        />
      </TableCell> */}
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {formatDate(row.salary_date)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_month}
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_this_month}
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.salary_status == 'paid'
                ? classes.activeStatus
                : row.salary_status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.salary_status == 'Paid'
                    ? '#14804a'
                    : row.salary_status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.salary_status}
          </span>
        </div>
      </TableCell>
      {/* <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_last_year_due}
      </TableCell> */}

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {parseInt(row.student_misc_fee, 10)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.fee_balance?.toFixed(2)}
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_amount}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.paid_exam_fee}
      </TableCell>
    </>
  )
}
export const HolidayFields = ({ row, labelId, rowIndex }) => {
  return (
    <>
      <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {rowIndex + 1} {/* Displaying index starting from 1 */}
      </TableCell>

      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.holiday_name}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {formatDate(row.holiday_date)}
      </TableCell>
      {/* <TableCell align="center">
        <div className="image-con-cell">
          <span className={row.status === 'Active' ? classes.activeStatus : classes.reject}>
            <StopIcon
              sx={{ color: row.status === 'Active' ? '#14804a' : '#d1293d' }}
              fontSize="10px"
            />
            {row.status == 'Active' ? 'Active' : 'Inactive'}
          </span>
        </div>
      </TableCell> */}
      {/* <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <div className="image-con-cell">
          <span
            className={
              row.student_fee_status == 'Paid'
                ? classes.activeStatus
                : row.student_fee_status == 'Partial Paid'
                  ? classes.partial
                  : classes.reject
            }
          >
            <StopIcon
              sx={{
                color:
                  row.student_fee_status == 'Paid'
                    ? '#14804a'
                    : row.student_fee_status == 'Partial Paid'
                      ? '#f0d137'
                      : '#d1293d',
              }}
              fontSize="10px"
            />
            {row.student_fee_status}
          </span>
        </div>
      </TableCell> */}
    </>
  )
}
const safeColumnId = (range) =>
  range
    .toLowerCase()
    .replace(/[:\s]/g, '_')
    .replace(/-/g, '_to_')
    .replace(/[^a-z0-9_]/g, '')
export const TimeTableTeacherFields = ({ row, labelId, search, headCells }) => {
  // headCells is passed from parent (the dynamic ones we generated)
  // We use it to know which time slot columns exist

  const dispatch = useDispatch()

  const [avatarColors, setAvatarColors] = React.useState({})

  const getColorForTeacher = (teacherId) => {
    if (avatarColors[teacherId]) {
      return avatarColors[teacherId]
    }
    const newColor = getRandomColor()
    setAvatarColors((prev) => ({ ...prev, [teacherId]: newColor }))
    return newColor
  }

  // Find all dynamic time slot columns (those with '_to_' in id)
  const timeSlotColumns = headCells?.filter((h) => h.id.includes('_to_')) || []

  // console.log('----timeSlotColumns',timeSlotColumns);

  return (
    <>
      {/* Fixed columns - Teacher Name */}
      {/* <TableCell align="center" component="th" id={labelId} scope="row" padding="none">
        {row.teacher_name || '—'}
      </TableCell> */}

      {/* Teacher ID or Avatar (optional - adjust as needed) */}
      <TableCell align="center">
        <TableImageHolder
          fieldImage={row.teacher_avatar} // if you have teacher avatar
          fieldName={row.teacher_name}
          avatarColor={getColorForTeacher(row.teacher_id)}
        />
      </TableCell>

      {/* Dynamic Time Slot Columns */}
      {timeSlotColumns.map((col) => {
        const timeRange = col.label // e.g. "8:00 AM - 8:30 AM"
        const colId = col.id

        // Find matching slot for this time range
        const slot = row.slots?.find(
          (s) => `${s.slot_start_timing} - ${s.slot_end_timing}` === timeRange,
        )

        let cellContent = '—'

        if (slot) {
          cellContent = (
            <div style={{ textAlign: 'center' }}>
              {slot.grade || '—'}-{slot.section || '—'}
              {/* <strong>{slot.subject_name || '—'}</strong> */}
              {/* <br /> */}
              {/* {slot.second_teacher_name && (
                <div style={{ fontSize: '0.8em', color: '#666' }}>
                  2nd: {slot.second_teacher_name}
                </div>
              )} */}
            </div>
          )
        }
        // console.log('--cellContent',cellContent);

        return (
          <TableCell key={colId} align="center" sx={{ whiteSpace: 'nowrap' }}>
            {cellContent}
          </TableCell>
        )
      })}

      {/* Optional static columns at the end (if you still want them) */}
    </>
  )
}
export const TimeTableGradeFields = ({ row, labelId, search, headCells }) => {
  // headCells is passed from parent (the dynamic ones we generated)
  // We use it to know which time slot columns exist

  const dispatch = useDispatch()

  const [avatarColors, setAvatarColors] = React.useState({})

  const getColorForTeacher = (teacherId) => {
    if (avatarColors[teacherId]) {
      return avatarColors[teacherId]
    }
    const newColor = getRandomColor()
    setAvatarColors((prev) => ({ ...prev, [teacherId]: newColor }))
    return newColor
  }

  // Find all dynamic time slot columns (those with '_to_' in id)
  const timeSlotColumns = headCells?.filter((h) => h.id.includes('_to_')) || []

  // console.log('----timeSlotColumns',timeSlotColumns);

  return (
    <>
      {/* Grade & Section column */}
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {row.grade} - {row.section}
      </TableCell>

      {/* Dynamic Time Slot Columns */}
      {timeSlotColumns.map((col) => {
        const timeRange = col.label // e.g. "07:30 - 08:30"

        // Find ALL slots that match this exact time range
        const matchingSlots =
          row.slots?.filter((s) => `${s.slot_start_timing} - ${s.slot_end_timing}` === timeRange) ||
          []

        let cellContent = '—'

        if (matchingSlots.length > 0) {
          // Collect subject names (only if they exist)
          const subjectNames = matchingSlots
            .map((slot) => slot.subject_name?.trim())
            .filter(Boolean) // remove empty / falsy values

          if (subjectNames.length > 0) {
            // Join with " - " (dash with spaces)
            cellContent = (
              <div style={{ textAlign: 'center', lineHeight: 1.4 }}>{subjectNames.join(' - ')}</div>
            )
          }
        }

        return (
          <TableCell key={col.id} align="center" sx={{ whiteSpace: 'nowrap', minWidth: 140 }}>
            {cellContent}
          </TableCell>
        )
      })}
    </>
  )
}
